import { render, staticRenderFns } from "./PayeeInfoPreview.vue?vue&type=template&id=a763db48&scoped=true&functional=true&"
import script from "./PayeeInfoPreview.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoPreview.vue?vue&type=style&index=0&id=a763db48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a763db48",
  null
  
)

export default component.exports